export const PRICE_DECIMALS = 2;

/** Rounds to price precision. Null for anything non-finite. */
export function roundPrice(value: number | null | undefined): number | null {
  if (value == null) return null;
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  // Via toFixed so the result always equals what the templates render.
  return Number(num.toFixed(PRICE_DECIMALS));
}

/** Equality at price precision, so a rounded value still matches its raw source. */
export function samePrice(a: number | null | undefined, b: number | null | undefined): boolean {
  const left = roundPrice(a);
  const right = roundPrice(b);
  return left !== null && right !== null && left === right;
}
